import { Page as CompetitionRegistrationListPage } from './pages/competition/detail/registration/list/page';
import { Page as CreateCompetitionDivisionPage } from './pages/competition/divisions/create/page';
import { Page as EditCompetitionDivisionPage } from './pages/competition/divisions/edit/page';
import { Page as CreateCompetitionTeamPage } from './pages/competition/teams/create/page';
import { Page as EditCompetitionTeamPage } from './pages/competition/teams/edit/page';
import { Page as ResetPasswordRequestSuccessPage } from './pages/auth/reset-password/request/success/page';
import { Page as ResetPasswordConfirmSuccessPage } from './pages/auth/reset-password/confirm/success/page';
import { Page as EditCompetitionRegistrationPage } from './pages/competition/detail/registration/edit/page';
import { Page as CompetitionManageRegistrationPage } from './pages/competition/detail/registration/page';
import { Page as ResetPasswordConfirmErrorPage } from './pages/auth/reset-password/confirm/error/page';
import { Page as AuthSignUpVerifySuccessPage } from './pages/auth/sign-up/verify/success/page';
import { Page as CompetitionManageResultPage } from './pages/competition/result/manage/page';
import { Page as ResetPasswordRequestPage } from './pages/auth/reset-password/request/page';
import { Page as ResetPasswordConfirmPage } from './pages/auth/reset-password/confirm/page';
import { Page as AuthSignUpVerifyErrorPage } from './pages/auth/sign-up/verify/error/page';
import { Page as SetCompetitionCategoryPage } from './pages/competition/set-category/page';
import { Page as CreateRefereeLicensePage } from './pages/referee-licenses/create/page';
import { Page as TeamManageRoundResultsPage } from './pages/round-results/manage/page';
import { Page as CreateStandardRecordPage } from './pages/standard-record/create/page';
import { Page as EditRefereeLicensePage } from './pages/referee-licenses/edit/page';
import { Page as StandardRecordListPage } from './pages/standard-record/list/page';
import { Page as EditStandardRecordPage } from './pages/standard-record/edit/page';
import { Page as AuthSignUpSuccessPage } from './pages/auth/sign-up/success/page';
import { Page as ListDistrictAdminPage } from './pages/district/admin/list/page';
import { Page as AuthSignUpVerifyPage } from './pages/auth/sign-up/verify/page';
import { Page as CreateCompetitionPage } from './pages/competition/create/page';
import { Page as CompetitionDetailPage } from './pages/competition/detail/page';
import { Page as CompetitionResultPage } from './pages/competition/result/page';
import { Page as RefereeLicensePage } from './pages/referee-licenses/list/page';
import { Page as AdminCompetitionPage } from './pages/admin/competitions/page';
import { Page as CreateLifterLicensePage } from './pages/licenses/create/page';
import { Page as RecordManageListPage } from './pages/record/manage/list/page';
import { Page as EditRecordManagePage } from './pages/record/manage/edit/page';
import { Page as AdminCreateUserPage } from './pages/admin/users/create/page';
import { Page as CompetitionListPage } from './pages/competition/list/page';
import { Page as EditCompetitionPage } from './pages/competition/edit/page';
import { Page as EditLifterLicensePage } from './pages/licenses/edit/page';
import { Page as DivisionDetailPage } from './pages/divisions/detail/page';
import { Page as CreateDivisionPage } from './pages/divisions/create/page';
import { Page as CreateDistrictPage } from './pages/district/create/page';
import { Page as DistrictDetailPage } from './pages/district/detail/page';
import { Page as AdminEditUserPage } from './pages/admin/users/edit/page';
import { Page as AdminUserListPage } from './pages/admin/users/list/page';
import { Page as AdminDistrictPage } from './pages/admin/districts/page';
import { Page as ListClubAdminPage } from './pages/club/admin/list/page';
import { Page as CreateRefereePage } from './pages/referee/create/page';
import { Page as RefereeDetailPage } from './pages/referee/detail/page';
import { Page as AdminMyTeamsPage } from './pages/admin/my-teams/page';
import { Page as DivisionListPage } from './pages/divisions/list/page';
import { Page as EditDivisionPage } from './pages/divisions/edit/page';
import { Page as LifterLicensePage } from './pages/licenses/list/page';
import { Page as LifterDetailPage } from './pages/lifter/detail/page';
import { Page as CreateLifterPage } from './pages/lifter/create/page';
import { Page as DistrictListPage } from './pages/district/list/page';
import { Page as EditDistrictPage } from './pages/district/edit/page';
import { Page as SeriesDetailPage } from './pages/series/detail/page';
import { Page as CreateSeriesPage } from './pages/series/create/page';
import { Page as CreateRoundPage } from './pages/rounds/create/page';
import { Page as RankingListPage } from './pages/ranking/list/page';
import { Page as RefereeListPage } from './pages/referee/list/page';
import { Page as EditRefereePage } from './pages/referee/edit/page';
import { Page as AuthSignInPage } from './pages/auth/sign-in/page';
import { Page as AuthSignUpPage } from './pages/auth/sign-up/page';
import { Page as CreateTeamPage } from './pages/teams/create/page';
import { Page as CreateClubPage } from './pages/club/create/page';
import { Page as EditLifterPage } from './pages/lifter/edit/page';
import { Page as LifterListPage } from './pages/lifter/list/page';
import { Page as ClubDetailPage } from './pages/club/detail/page';
import { Page as RecordListPage } from './pages/record/list/page';
import { Page as SeriesListPage } from './pages/series/list/page';
import { Page as EditSeriesPage } from './pages/series/edit/page';
import { Page as AdminClubPage } from './pages/admin/clubs/page';
import { Page as EditRoundPage } from './pages/rounds/edit/page';
import { Page as RoundListPage } from './pages/rounds/list/page';
import { Page as TeamListPage } from './pages/teams/list/page';
import { Page as EditTeamPage } from './pages/teams/edit/page';
import { Page as ClubListPage } from './pages/club/list/page';
import { Page as EditClubPage } from './pages/club/edit/page';
import { Page as TeamDetailPage } from './pages/teams/page';

import { createBrowserRouter, Navigate } from 'react-router';
import { PageLayout } from './components/PageLayout/PageLayout';
import { Layout as AdminLayout } from './pages/admin/layout';
import { Page as ErrorPage } from './pages/error/Page';
import { Layout } from './components/Layout/Layout';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: '/',
        element: <Navigate to="/rankings" />,
      },
      {
        path: '/competitions',
        element: <PageLayout title="Tävlingar" />,
        children: [
          {
            path: '',
            element: <CompetitionListPage />,
          },
          {
            path: ':id',
            element: <CompetitionDetailPage />,
          },
          {
            path: ':id/registrations',
            element: <CompetitionRegistrationListPage />,
          },
          {
            path: ':id/registrations/manage',
            element: <CompetitionManageRegistrationPage />,
          },
          {
            path: ':id/registrations/:registrationId/edit',
            element: <EditCompetitionRegistrationPage />,
          },
          {
            path: ':id/results',
            element: <CompetitionResultPage />,
          },
          {
            path: ':id/results/manage',
            element: <CompetitionManageResultPage />,
          },
          {
            path: ':id/edit',
            element: <EditCompetitionPage />,
          },
          {
            path: ':id/set-categories',
            element: <SetCompetitionCategoryPage />,
          },
          {
            path: ':id/divisions/create',
            element: <CreateCompetitionDivisionPage />,
          },
          {
            path: ':id/divisions/:divisionId/edit',
            element: <EditCompetitionDivisionPage />,
          },
          {
            path: ':id/teams/create',
            element: <CreateCompetitionTeamPage />,
          },
          {
            path: ':id/teams/:teamId/edit',
            element: <EditCompetitionTeamPage />,
          },
          {
            path: 'create',
            element: <CreateCompetitionPage />,
          },
        ],
      },
      {
        path: '/clubs',
        element: <PageLayout title="Föreningar" />,
        children: [
          {
            path: '',
            element: <ClubListPage />,
          },
          {
            path: ':id',
            element: <ClubDetailPage />,
          },
          {
            path: ':id/edit',
            element: <EditClubPage />,
          },
          {
            path: ':id/admins',
            element: <ListClubAdminPage />,
          },
          {
            path: 'create',
            element: <CreateClubPage />,
          },
        ],
      },
      {
        path: '/districts',
        element: <PageLayout title="Distrikt" />,
        children: [
          {
            path: '',
            element: <DistrictListPage />,
          },
          {
            path: ':id',
            element: <DistrictDetailPage />,
          },
          {
            path: ':id/edit',
            element: <EditDistrictPage />,
          },
          {
            path: ':id/admins',
            element: <ListDistrictAdminPage />,
          },
          {
            path: 'create',
            element: <CreateDistrictPage />,
          },
        ],
      },
      {
        path: '/referees',
        element: <PageLayout title="Domare" />,
        children: [
          {
            path: '',
            element: <RefereeListPage />,
          },
          {
            path: ':id',
            element: <RefereeDetailPage />,
          },
          {
            path: ':id/edit',
            element: <EditRefereePage />,
          },
          {
            path: 'create',
            element: <CreateRefereePage />,
          },
          {
            path: ':id/licenses',
            element: <RefereeLicensePage />,
          },
          {
            path: ':id/licenses/create',
            element: <CreateRefereeLicensePage />,
          },
          {
            path: ':id/licenses/:licenseId/edit',
            element: <EditRefereeLicensePage />,
          },
        ],
      },
      {
        path: 'series',
        element: <PageLayout title="Serier" />,
        children: [
          {
            path: '',
            element: <SeriesListPage />,
          },
          {
            path: 'create',
            element: <CreateSeriesPage />,
          },
          {
            path: ':seriesId',
            element: <SeriesDetailPage />,
          },
          {
            path: ':seriesId/edit',
            element: <EditSeriesPage />,
          },
          {
            path: 'divisions',
            element: <DivisionListPage />,
          },
          {
            path: 'divisions/create',
            element: <CreateDivisionPage />,
          },
          {
            path: 'divisions/:divisionId/edit',
            element: <EditDivisionPage />,
          },
          {
            path: 'divisions/:divisionId',
            element: <DivisionDetailPage />,
          },
          {
            path: 'teams',
            element: <TeamListPage />,
          },
          {
            path: 'divisions/:divisionId/teams/:teamId',
            element: <TeamDetailPage />,
          },
          {
            path: 'teams/create',
            element: <CreateTeamPage />,
          },
          {
            path: 'teams/:teamId/edit',
            element: <EditTeamPage />,
          },
          {
            path: 'divisions/:divisionId/teams/:teamId/manage/rounds/:roundId',
            element: <TeamManageRoundResultsPage />,
          },
          {
            path: 'rounds',
            element: <RoundListPage />,
          },
          {
            path: 'rounds/create',
            element: <CreateRoundPage />,
          },
          {
            path: 'rounds/:roundId/edit',
            element: <EditRoundPage />,
          },
        ],
      },
      {
        path: 'lifters',
        element: <PageLayout title="Lyftare" />,
        children: [
          {
            path: '',
            element: <LifterListPage />,
          },
          {
            path: ':id',
            element: <LifterDetailPage />,
          },
          {
            path: ':id/edit',
            element: <EditLifterPage />,
          },
          {
            path: 'create',
            element: <CreateLifterPage />,
          },
          {
            path: ':id/licenses',
            element: <LifterLicensePage />,
          },
          {
            path: ':id/licenses/create',
            element: <CreateLifterLicensePage />,
          },
          {
            path: ':id/licenses/:licenseId/edit',
            element: <EditLifterLicensePage />,
          },
        ],
      },
      {
        path: 'rankings',
        element: <PageLayout title="Ranking" />,
        children: [
          {
            path: '',
            element: <RankingListPage />,
          },
        ],
      },
      {
        path: 'records',
        element: <PageLayout title="Rekord" />,
        children: [
          {
            path: '',
            element: <RecordListPage />,
          },
          {
            path: 'manage',
            element: <RecordManageListPage />,
          },
          {
            path: 'manage/:id',
            element: <EditRecordManagePage />,
          },
        ],
      },
      {
        path: 'admin',
        element: <AdminLayout />,
        children: [
          {
            path: '',
            element: <Navigate to="my-clubs" />,
          },
          {
            path: 'my-clubs',
            element: <AdminClubPage />,
          },
          {
            path: 'my-districts',
            element: <AdminDistrictPage />,
          },
          {
            path: 'my-competitions',
            element: <AdminCompetitionPage />,
          },
          {
            path: 'my-teams',
            element: <AdminMyTeamsPage />,
          },
          {
            path: 'users',
            element: <AdminUserListPage />,
          },
          {
            path: 'users/create',
            element: <AdminCreateUserPage />,
          },
          {
            path: 'users/:id/edit',
            element: <AdminEditUserPage />,
          },
          {
            path: 'standard-records',
            element: <StandardRecordListPage />,
          },
          {
            path: 'standard-records/:id/edit',
            element: <EditStandardRecordPage />,
          },
          {
            path: 'standard-records/create',
            element: <CreateStandardRecordPage />,
          },
        ],
      },
      {
        path: '/auth',
        element: <PageLayout width="narrow" />,
        children: [
          {
            path: 'sign-in',
            element: <AuthSignInPage />,
          },
          {
            path: 'sign-up',
            element: <AuthSignUpPage />,
          },
          {
            path: 'sign-up/success',
            element: <AuthSignUpSuccessPage />,
          },
          {
            path: 'sign-up/verify/:token',
            element: <AuthSignUpVerifyPage />,
          },
          {
            path: 'sign-up/verify/success',
            element: <AuthSignUpVerifySuccessPage />,
          },
          {
            path: 'sign-up/verify/error',
            element: <AuthSignUpVerifyErrorPage />,
          },
          {
            path: 'reset-password/request',
            element: <ResetPasswordRequestPage />,
          },
          {
            path: 'reset-password/request/success',
            element: <ResetPasswordRequestSuccessPage />,
          },
          {
            path: 'reset-password/confirm/:token',
            element: <ResetPasswordConfirmPage />,
          },
          {
            path: 'reset-password/confirm/success',
            element: <ResetPasswordConfirmSuccessPage />,
          },
          {
            path: 'reset-password/confirm/error',
            element: <ResetPasswordConfirmErrorPage />,
          },
        ],
      },
    ],
  },
]);
